export default class GatedContentButton {

    constructor() {
        this.settings = {
            $gatedContentPage: $('[data-block="gated-content-landing-page"]')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$gatedContentPage.length > 0) {
            $(document).ready(() => {
                $(document).on('gform_confirmation_loaded', () => {
                    const $downloadButton = $('#gated-cta-button');
                    $downloadButton.removeAttr('disabled').removeClass('pointer-events-none');
                });
            });
        }

    }
};

new GatedContentButton();